import { useContext, useMemo } from "react";
import { BreadcrumbContext, BreadcrumbTitleSetter } from "../BreadcrumbContext";

/**
 * Provides methods for the manipulation of the current breadcrumb if any.
 * @returns A tuple containing a function for setting the current breadcrumb title.
 */
export function useCurrentBreadcrumb(): [BreadcrumbTitleSetter] {
  const { setTitle } = useContext(BreadcrumbContext);

  return useMemo((): [BreadcrumbTitleSetter] => {
    return [setTitle];
  }, [setTitle]);
}
